<template>
  <div v-if="showPopup" id="popupBG" class="popupBG" @click="showPopup = false">
    <div class="popupContainer" :style="xs ? 'width:90%' : 'width:50%'">
        <div class="popUp">
            <v-icon class="icon-close">mdi-close-box</v-icon>
            <a href="/parceiros">
              <img :src="popupParceiros">
            </a>
        </div>		
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import popupParceiros from '@/assets/popupParceiros.jpg';
import { useDisplay } from 'vuetify';
let showPopup = ref(true);
const { xs } = useDisplay();
</script>

<style scoped>
.popupBG {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 100;
  top: 0px;
  left: 0px;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  justify-content: center;
  background-color: rgb(0 0 0 / 50%);
}
.popupContainer {
    /*width: 700px;*/
    display: flex;
    justify-content: center;
    align-items: center;
}
.popUp {
    width: 100%;
    max-width: 1200px;
    height: auto;
}
.popUp img {
    width: 100%;
    margin: 0 auto;
    display: block;
}
.popUp .icon-close {
    color:white;
    float:right;
}
</style>